module.exports = __webpack_public_path__ + "img/emoji.df19373c.svg";